module.exports = "/images/merchant-placeholder-avatar.png";